import React, { FunctionComponent } from "react";
import { Grid, Typography, Container } from "@mui/material";
import { Topic } from "../../context/ConfigContext/types";
import GenericSelectCard from "../GenericSelectCard";
import { ClientAccess } from "../../context/ClientAccessContext/types";

export enum SelectType {
  Client = "Client",
  Topic = "Topic",
}

interface GenericSelectLayoutProps {
  items: ClientAccess[] | Topic[];
  onCardClick: (id: any) => void;
  type: SelectType;
}

const GenericSelectLayout: FunctionComponent<GenericSelectLayoutProps> = ({ items, onCardClick, type }) => {
  return (
    <Container maxWidth={false}>
      <Grid container justifyContent="start">
        <Typography sx={{ marginTop: 7.5, marginBottom: 3 }} variant="h4">
          Select {type}
        </Typography>
        <Grid item xs={12} container direction="row" justifyContent="start" spacing={3}>
          {items.length
            ? items.map((item, index) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
                    <GenericSelectCard item={item} onClick={() => onCardClick(item)} />
                  </Grid>
                );
              })
            : ""}
        </Grid>
      </Grid>
    </Container>
  );
};

export default GenericSelectLayout;
